import React, { Component } from "react";
import { PropTypes } from "prop-types";
import CSSModules from "react-css-modules";
import classnames from "classnames";
import TableColumnFilter from "./TableColumnFilter/TableColumnFilter_component";
import * as filterUtils from "@/common/utils/Tables/filters";
import styles from "./styles.scss";

class TableHeaderCell extends Component {
  constructor(props) {
    super(props);
    this.displayName = 'TableHeaderCell_container';
    this.state = {
      filterVisible: props.filter && props.filter.visible,
      isSortColumn: true,
      sortingClass: "fa fa-caret-down",
      sortDir: this.props.sortDir,
      filterAplayed: this.props.colData.filterAplayed
      //filterData: this.props.filterData
    };

    this.closeFilter = this.closeFilter.bind(this);
    this.toggleSortComponent = this.toggleSortComponent.bind(this);
    this.getColumnIcons = this.getColumnIcons.bind(this);
    this.toggleFilterComponent = this.toggleFilterComponent.bind(this);
    this.getFilterComponent = this.getFilterComponent.bind(this);
    this.searchInFilter = this.searchInFilter.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.loadMore = this.loadMore.bind(this);
  }

  toggleSortComponent() {
    let sortDir = "";
    let options = { sortingClass: "", sortDir: "" };

    if (this.state.sortDir === "asc") {
      sortDir = "desc";
      options = { sortingClass: "fa fa-sort-desc", sortDir };
      /* this.setState(
        { sortingClass: "fa fa-sort-desc", sortDir },
        () => {
					console.log('proceeding sort action');
				}
      ); */
    } else if (this.state.sortDir === "desc") {
      sortDir = "";
      options = { sortingClass: "fa fa-sort", sortDir };
      /* this.setState(
        { sortingClass: "fa fa-sort", sortDir },
        () => {
					console.log('proceeding sort action');
				}
      ); */
    } else {
      sortDir = "asc";
      options = { sortingClass: "fa fa-sort-desc", sortDir };
      /* this.setState(
        { sortingClass: "fa fa-sort-desc", sortDir },
        () => {
					console.log('proceeding sort action');
				}
      ); */
    }

    this.setState(options, this.props.onSortToggle(this.state.sortDir, true));
  }

  toggleFilterComponent() {
    this.props.toggleFilter(this.props.colData.key.toLowerCase());
    /*if (this.props.filter && this.props.filter.visible === true) {
	 return;
	 }

	 this.props.getFilter({columnId: this.props.colData.key.toLowerCase()});*/
  }

  closeFilter() {
    this.toggleFilterComponent();
  }

  getColumnIcons(isSort, filterable) {
    //return (<i className="fa fa-filter"/>);
    const filterIconClasses = classnames({
      'fa fa-filter': true,
      'visible-filter': this.props.filter && this.props.filter.visible === true,
      'filter-aplayed' : this.state.filterAplayed
    });

    const filterArrowIconClasses = classnames({
        'fa fa-sort-desc': true,
        'visible-filter': this.props.filter && this.props.filter.visible === true,
        'filter-aplayed' : this.state.filterAplayed
      });

    if (isSort) {
      if (this.state.sortDir === "asc") {
        return <i className="fa fa-sort-asc" />;
      } else if (this.state.sortDir === "desc") {
        return <i className="fa fa-sort-desc" />;
      } else {
        return <i className="fa fa-sort " />;
      }
    } else if (filterable === true) {
      return (
        <span>
          <i className={filterArrowIconClasses} />
          <i className={filterIconClasses} />
        </span>
      );
      //return null;
    } else {
      return null;
    }
  }

  getFilterComponent(filterable) {
    if (
      this.props.filter === null ||
      this.props.filter.visible === false ||
      filterable === false
    ) {
      return null;
    }
    return (
      <TableColumnFilter
        closeFilter={this.closeFilter}
        applyFilter={this.applyFilter}
        searchInFilter={this.searchInFilter}
        columnName={this.props.colData.key.toLowerCase()}
        filterData={this.props.filter}
        loadMore={this.loadMore}
      />
    );
  }

  searchInFilter(filterValue) {
    this.props.searchInFilter({
      searchQuery: filterValue,
      columnId: this.props.colData.key.toLowerCase()
    });
  }

  loadMore({
    chunkSize,
    lastFilterItemIndex,
    isSelectAll,
    selectAllChanged,
    searchQuery
  }) {
    this.props.loadMore({
      chunkSize: chunkSize,
      lastFilterItemIndex: lastFilterItemIndex,
      columnId: this.props.colData.key.toLowerCase(),
      isSelectAll: isSelectAll,
      selectAllChanged: selectAllChanged,
      searchQuery: searchQuery
    });
  }

  applyFilter({ isSelectAll, selectAllChanged, options, items, ...params }) {
    console.log("Applying: ", params, isSelectAll, options, items);
    console.log("Current filter: ", this.props.filter);
    let filter = { ...this.props.filter };
    console.log("Filter: ", filter);
    if (filterUtils.isMultichoiceFilterType(filter.columnId)) {
      filter.options = options;
      this.setState({filterAplayed: !isSelectAll});
    } else if (filterUtils.isRangeFilterType(filter.columnId)) {
      const isRangeFilterAplayed = !((items.from == this.props.filter.min) && (items.to == this.props.filter.max));
      this.setState({filterAplayed: isRangeFilterAplayed});
      filter.from = items.from;
      filter.to = items.to;
    }
    this.props.applyFilter({ filter, isSelectAll, selectAllChanged });
  }

  render() {
    //console.log(this.props);

    //const styleObject = {'background': 'red', color: 'white'};

    const cellStyleName = `cell ${this.props.colData.key}`;
    let onTblColClick = this.toggleFilterComponent;
    const isSortAction = this.props.colData.key == "timestamp";
    if (isSortAction) {
      onTblColClick = this.toggleSortComponent;
    }
    return (
      <th styleName={cellStyleName}>
        <span styleName="text">{this.props.colData.label}</span>
        <div styleName="actions" onClick={onTblColClick}>
          {this.getColumnIcons(isSortAction, this.props.colData.filterable)}
        </div>
        {this.getFilterComponent(this.props.colData.filterable)}
      </th>
    );
  }
}

export default CSSModules(TableHeaderCell, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./components/qual/Table/TableHeader/TableHeaderCell/TableHeaderCell_container.js